import { Directive, OnChanges, SimpleChanges, Input, ElementRef, Output, inject } from '@angular/core';

import { HisBaseGlobalsService } from '../../core/service/base/his-base-globals.service';
import { Steps } from 'primeng/steps';


@Directive( {
    exportAs: 'p-steps',
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'p-steps',
    standalone: false
} )
export class HisStepsDirective implements OnChanges {
    elementRef = inject(ElementRef);
    hisBaseGlobalsService = inject(HisBaseGlobalsService);
    private steps = inject(Steps, { optional: true });


    @Input() activeIndex: number;

    ngOnChanges(changes: SimpleChanges): void {
        if(changes && this.steps) {
            let index: number = this.activeIndex;
            setTimeout(() => {
                this.elementRef.nativeElement.children[0].children[0].children[index].focus();
            }, 5);
        }
    }
}
